import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";

const App = () => {
  return (
    <Router basename="/">
      <AppRoutes />
    </Router>
  );
};

export default App;
